import { useContext } from "react";

import { AppContext } from "../../../../lib/appContext";
import { useRouter } from "../../../../lib/routerContext";

export const useUrlPath = (): string => {
  const router = useRouter();
  const { businessUnitSlug } = useContext(AppContext);
  return (router && router.asPath && router.asPath.replace(`/${businessUnitSlug}`, "")) || "";
};
